import * as React from "react";
import classnames from "classnames";
import { MediaQuery } from "@grandvisionhq/common";
import { StepForm, ConfiguratorStepTitleAndDescription } from "@grandvisionhq/configurator";
/* empty css                                                                         */
/* empty css                                                                                                                   */
import { ConfiguratorRadioTile } from "../../../../../../components/ConfiguratorRadioTile/components/ConfiguratorRadioTile/ConfiguratorRadioTile.js";
import "@grandvisionhq/state";
import "../../../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../../../state/state/actions.js";
import "../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../state/bundles/state/bundles/reducer.js";
import "../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../state/products/state/products/selectors.js";
import "../../../../../../state/products/state/products/reducer.js";
import "@grandvisionhq/iris-ui";
import "@grandvisionhq/utils";
import "@grandvisionhq/lib-visuals";
/* empty css                                                                                                            */
/* empty css                                                                                                                                                             */
/* empty css                                                                                                          */
import "@grandvisionhq/commercetools";
/* empty css                                                                                                                                      */
/* empty css                                                                                                                                         */
/* empty css                                                                                                                                                                 */
import "@grandvisionhq/elements";
import "@grandvisionhq/icons";
/* empty css                                                                             */
/* empty css                                                                         */
/* empty css                                                                                              */
/* empty css                                                                                           */
import { FrameImage } from "../../../../FrameImage/steps/components/FrameImage/FrameImage.js";
/* empty css                                                                                                 */
import { RxStepWrapper } from "../../../../RxStepWrapper/steps/components/RxStepWrapper/RxStepWrapper.js";
import DesktopStepLayout from "../../../../DesktopStepLayout/steps/components/DesktopStepLayout/DesktopStepLayout.js";
/* empty css                          */
const VariantSelectionStep = ({
  className,
  itemsList,
  selectedItemSku,
  onChange,
  onSubmit
}) => {
  const showFrameImage = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  return /* @__PURE__ */ React.createElement(RxStepWrapper, { className: classnames("variant-selection-step", className) }, /* @__PURE__ */ React.createElement(DesktopStepLayout, null, /* @__PURE__ */ React.createElement(StepForm, { onSubmit, className: "variant-selection-step__wrapper" }, /* @__PURE__ */ React.createElement(ConfiguratorStepTitleAndDescription, { textAlignment: "left" }), showFrameImage && /* @__PURE__ */ React.createElement(FrameImage, null), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("variant-selection-step__products", className),
      "data-t": "variant-selection-step-products"
    },
    /* @__PURE__ */ React.createElement("fieldset", { className: "variant-selection-step__list" }, itemsList.map((item) => /* @__PURE__ */ React.createElement(
      ConfiguratorRadioTile,
      {
        className: "variant-selection-step__list-item",
        isSelected: selectedItemSku === item.sku,
        onChange,
        value: item.sku,
        key: item.sku,
        title: item.title,
        headerRowImage: item.image?.url,
        description: item.description,
        price: item.price,
        discountText: item.discountText
      }
    )))
  ))));
};
export {
  VariantSelectionStep
};
//# sourceMappingURL=VariantSelectionStep.js.map
